import React from 'react';
import BookTitle from '../components/BookTitle';
import Button from "../components/Button";
import { Link } from 'react-router';
import { Col } from 'react-bootstrap';

class Book extends React.Component {

    render(){
        let book;
        if (this.props.title){
            book = (
                <Col xs={12} md={6} >
                    <div className="book" >
                        <Link to={this.props.link}><img alt={this.props.title} src={this.props.book.coverImage}/></Link>
                        <BookTitle title={this.props.title}/>
                    </div>
                </Col>
            )
        } else if (this.props.buttonText){
            book = (
                <Col xs={12} md={6} >
                    <div className="book">
                        <Link to={this.props.link}><img alt="Cover" src={this.props.book.coverImage}/></Link>
                        <Button title={this.props.book.bookTitle} dropDownLinks={this.props.dropDownLinks} text={this.props.buttonText} type="buy"/>
                    </div>
                </Col>
            )
        } else {
            book = (               
                <div className="book">
                    <Link to={this.props.link}><img alt="Cover" src={this.props.book.coverImage}/></Link>
                </div>
            )
        }
        return (
            <div>
                { book }
            </div>
        )
    }
}

export default Book;


// WEBPACK FOOTER //
// ./src/components/Book.js